import React, { useState } from 'react';
import { useAppStateContext } from 'src/appState/AppState';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { RaceStreamButtonState } from './RaceStreamButton.state';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { WatchLiveButtonRaceCard } from 'src/domains/sportsbook/webview/components/raceCard/raceStreamButton/RaceStreamButton.style';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AccountState } from 'src/domains/players/shared/Types';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

interface PropType {
    race: EventModel;
}

export const RenderStreamButton = observer('RenderStreamButton', ({ race }: PropType): JSX.Element | null => {
    const common = useCommon();
    const { appSportsBookState } = useAppStateContext();
    const { betsState } = appSportsBookState;
    const streamingState = StreamingState.get(common);
    const languagesState = LanguagesState.get(common);
    const accountState = AccountState.get(common);
    const config = ConfigComponents.get(common).config;
    const [state] = useState(
        () =>
            new RaceStreamButtonState(
                race,
                streamingState,
                languagesState,
                accountState,
                betsState,
                config.shouldPlaceBetToWatchStream,
                common
            )
    );

    if (state.stream === null) {
        return null;
    }

    return (
        <WatchLiveButtonRaceCard
            isDisabled={state.isDisabled}
            onClick={state.onClickHandler}
            streamOn={streamingState.openEventId === race.id}
        >
            {state.buttonText}
        </WatchLiveButtonRaceCard>
    );
});
